<template>
	<div style="width: 100%;height: 100%;" class="item_font">
		<div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;">
			<div class="con" style="margin-bottom: 60px;font-weight: bold;font-size: 16px;">当前规则适用于所有人员</div>
			<!-- <div class="con">
				<el-radio v-model="value" label="1" @change="clickRadio">平均分配：按照权重系数加权后轮流分配</el-radio>
			</div>
			<div class="con">
				<el-radio v-model="value" label="2" @change="clickRadio">空闲优先：按照权重系数加权后优先分配空闲的座席</el-radio>
			</div> -->
			<div class="con" v-for="(item,index) in radioList" :key="index">
				<el-radio v-model="value" :label="item.id" @change="clickRadio">{{item.name}} : {{item.describes}}</el-radio>
			</div>
			<div class="con">
				<el-checkbox v-model="isAuto" @change="changeNum">自动分配给上次接待的客服人员</el-checkbox>
			</div>
		</div>
		<!-- <div class="con" style="color: #969696;margin-bottom: 70px;margin-top: 30px;">
			<div style="line-height: 25px;">

				<div>输入的权重值越大分配到的对话越多</div>
				<div>假设：A权重3 B权重2 C权重1，依次进来6个访客的分配情况如下:</div>
				<div>平均分配策略：A，A，A，B，B，C</div>
				<div>空闲优先策略：A，B，C，A，B，A</div>
			</div>
		</div> -->
		<div style="width: 160px; margin: 0 auto;margin-top: 80px;">
			<el-button type="primary" @click="addGlobalRulesConfirm">保存</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props: [],
		data() {
			return {
				value: "",
				isAuto: false,
				realName: "",
				userid: "",
				rulesId: "",
				originItem: {},
				radioList:[]
			}
		},
		mounted() {
			const account = JSON.parse(localStorage.getItem("account"));
			this.realName = account.realName
			this.userid = account.id
			console.log('account', account)
			this.selectGlobalRules()
		},
		methods: {
			clickRadio() {
				this.changeNum();
			},
			async selectGlobalRules() {
				var api = '/manager/globalRules/list'
				const response = await this.util.postRequest({
					url:api,
					method: 'POST',
					data:{
						
					}
				})
				
				console.log("selectGlobalRules response",response)
				this.radioList = response.data.globalRules
				for(let i = 0; i < this.radioList.length; i++){
					if(this.radioList[i].checked == 1){
						this.value = this.radioList[i].id
					}
				}
				this.isAuto = response.data.dist2last.checked == 1 ? true : false
				var item = {
					value: this.value,
					isAuto: this.isAuto,
				}
				this.originItem = JSON.parse(JSON.stringify(item));
				// var api = "/manager/globalRules/select";
				// const response = await this.util.postRequest({
				// 	url: api,
				// 	method: "POST",
				// 	data: {
				// 		"current": 0,
				// 		"id": "",
				// 		"size": 10,
				// 		"userId": this.userid,
				// 		"rulesType": "",
				// 		"rulesName": "",
				// 		"weight": "",
				// 		"disable": ""
				// 	}
				// });
				// var rulesTypeList = (response.data.globalRulesVoList[0].rulesType).split(",")
				// this.rulesId = response.data.globalRulesVoList[0].id
				// console.log('selectGlobalRules===>', response.data)
				// for (var i = 0; i < rulesTypeList.length; i++) {
				// 	if (rulesTypeList[i] === '1') {
				// 		console.log('aaaaa')
				// 		this.value = '1'
				// 	} else if (rulesTypeList[i] === '2') {
				// 		console.log('bbbbb')
				// 		this.value = '2'
				// 	} else if (rulesTypeList[i] === '3') {
				// 		console.log('ccccc')
				// 		this.isAuto = true
				// 	}
				// }
				// var item = {
				// 	value: this.value,
				// 	isAuto: this.isAuto,
				// }
				// this.originItem = JSON.parse(JSON.stringify(item));
			},
			async addGlobalRulesConfirm() {
				var api = "/manager/globalRules/setup";
				// var rulesType = ""
				// var rulesName = ""
				// if (this.value === '1' && !this.isAuto) {
				// 	rulesType = "1"
				// 	rulesName = "平均分配"
				// }
				// if (this.value === '1' && this.isAuto) {
				// 	rulesType = "1,3"
				// 	rulesName = "平均分配,自动分配"
				// }
				// if (this.value === '2' && !this.isAuto) {
				// 	rulesType = "2"
				// 	rulesName = "空闲分配"
				// }
				// if (this.value === '2' && this.isAuto) {
				// 	rulesType = "2,3"
				// 	rulesName = "空闲分配,自动分配"
				// }
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: [
							{
								id: '0',
								checked: this.isAuto == true ? 1 : 0
							},{
								id: this.value,
								checked: 1
							}
						]
					
				});
				if (response.resultCode === "10000") {
					const tipMsg = '保存成功'
					this.$message.success(tipMsg)
					this.$emit('changeNum', {
						tableName: 'all',
						isSave: false
					})
				} else {
					this.$message.error(response.desc)
				}
				// this.selectGlobalRules()
			},
			changeNum() {
				console.log(this.originItem);
				if (this.originItem.value != this.value || this.originItem.isAuto != this.isAuto) {
					this.$emit('changeNum', {
						tableName: 'all',
						isSave: true
					})
				} else {
					this.$emit('changeNum', {
						tableName: 'all',
						isSave: false
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.con {
		margin-bottom: 20px;
		@include change_size($font_size_normal)
	}

	.el-checkbox__label {
		@include change_size($font_size_normal)
	}

	.el-radio__label {
		@include change_size($font_size_normal)
	}
</style>
